import React, { useState, MouseEvent, useEffect } from 'react';
import { ChevronDownIcon } from './icons';
import tokens from '../theme/tokens';

interface CustomSelectProps {
    options: string[];
    value?: string;
    placeholder?: string;
    onChange?: (value: string) => void;
}

const CustomSelect: React.FC<CustomSelectProps> = ({ options, value = "", placeholder = 'Select an option', onChange }) => {
    const [selected, setSelected] = useState<string>(value);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        setSelected(value)
    }, [value])

    const handleSelect = (option: string) => {
        setSelected(option);
        onChange?.(option); // call if provided
        setIsOpen(false);
    };

    const handleOverlayClick = () => {
        setIsOpen(false);
    };

    const stopPropagation = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    return (
        <>
            <div onClick={() => setIsOpen(true)} style={styles.button}>
                {selected || 'Select an option'} <ChevronDownIcon />
            </div>

            {isOpen && (
                <div style={styles.modalOverlay} onClick={handleOverlayClick}>
                    <div style={styles.bottomSheet} onClick={stopPropagation}>
                        {/* <h3 style={styles.title}>{placeholder}</h3> */}
                        {options.map((option) => (
                            <div
                                key={option}
                                onClick={() => handleSelect(option)}
                                style={styles.option}
                            >
                                {option}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default CustomSelect;

const styles: { [key: string]: React.CSSProperties } = {
    button: {
        padding: '12px 20px',
        fontSize: '16px',
        // borderRadius: '6px',
        // border: `1px solid ${tokens.brand[300]}`,
        cursor: 'pointer',
        width: '100%',
        maxWidth: '300px',
        textAlign: 'right'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-end',
    },
    bottomSheet: {
        height: '35dvh',
        width: '100%',
        backgroundColor: 'white',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        padding: '20px',
        boxSizing: 'border-box',
    },
    title: {
        margin: 0,
        marginBottom: '16px',
        fontSize: '18px',
    },
    option: {
        padding: '12px 0',
        borderBottom: `1px solid ${tokens.brand[100]}`,
        cursor: 'pointer',
    },
};
